import React from 'react';

import {
  deleteMessageConsumer,
  selectMessageConsumer,
  likeMessageConsumer,
  saveMessageChangesConsumer,
  getMessageLogsConsumer,
} from '../../../../redux/consumer/id8/consumerId8Actions';
import MessagesOutput from '../../../../id8/components/message-output/MessagesOutput';

function CommonMessagesOutput({ bindAction, searchFunction, isShowGenerationForm }) {
  return (
    <MessagesOutput
      bindNextAction={bindAction}
      onSearch={searchFunction}
      onSelect={selectMessageConsumer}
      onDelete={deleteMessageConsumer}
      onLike={likeMessageConsumer}
      onSaveMessage={saveMessageChangesConsumer}
      getMessageLogs={getMessageLogsConsumer}
      maxHeight={isShowGenerationForm ? 'calc(100vh - 520px)' : 'calc(100vh - 340px)'}
    />
  );
}

export default CommonMessagesOutput;
